import React, { useEffect, useState } from 'react';
import Box from '@mui/material/Box';
import { DataGrid } from '@mui/x-data-grid';
import { getDbConfigurationList, updateDbConigure, deleteDbConigure } from '../../services/user.service';
import * as CryptoJS from "crypto-js";

/* ─── Same CSS as ViewAllocation ─── */
import '../ExcelUploads/AssetInfo/AssetInfo.css';
import '../ExcelUploads/AssetInfo/AssetList.css';

/* ─── Date Helpers (unchanged) ─── */
Date.prototype.dbFormatedDate = function () {
    let year = this.getFullYear();
    let month = this.getMonth() + 1;
    let day = this.getDate();
    if (month < 10) month = '0' + month;
    if (day < 10) day = '0' + day;
    return year + '-' + month + '-' + day;
};

function getFormatedDate(dateString) {
    if (dateString !== null) {
        let dte = new Date(dateString);
        let year = dte.getFullYear();
        let month = dte.getMonth() + 1;
        let day = dte.getDate();
        if (month < 10) month = '0' + month;
        if (day < 10) day = '0' + day;
        return year + '-' + month + '-' + day;
    } else {
        return null;
    }
}

function DbConfigureList() {
    const [items, setItems] = useState([]);
    const [loading, setLoading] = useState(true);
    const [errMsg, setErrMsg] = useState('');
    const [success, setSuccess] = useState(false);

    /* ─── Columns (unchanged logic) ─── */
    const columns = [
        { field: "company_name", hide: false, headerName: "Company Name",       width: 250 },
        { field: "db_host",      hide: false, headerName: "Host Name",           width: 150 },
        { field: "db_name",      hide: false, headerName: "Database Name",       width: 200 },
        { field: "db_user",      hide: false, headerName: "Database User",       width: 160 },
        {
            field: "db_pass", hide: false, headerName: "Password", width: 140,
            renderCell: () => <span>{'*'.repeat(8)}</span>
        },
        { field: "db_port", hide: false, headerName: "Port", width: 100 },
        {
            field: 'status', headerName: 'Status', width: 110,
            renderCell: (params) => {
                const isActive = params.row.status === 1;
                return (
                    <span className={`badge ${isActive ? 'bg-success' : 'bg-secondary'}`}>
                        {isActive ? 'Active' : 'Inactive'}
                    </span>
                );
            }
        },
        {
            field: 'actions', headerName: 'Actions', width: 200,
            renderCell: (params) => {
                const isActive = params.row.status === 1;
                return (
                    <span>
                        <button
                            type="button"
                            className={`btn btn-sm ${isActive ? 'btn-warning' : 'btn-success'}`}
                            onClick={() => handleUpdatestatus(params.row.id, params.row.status)}
                        >
                            {isActive ? 'Deactivate' : 'Activate'}
                        </button>
                        &nbsp;
                        <button
                            type="button"
                            className="btn btn-danger btn-sm"
                            onClick={() => handleDeleteClick(params.row.id)}
                        >
                            <i className="bi bi-trash" />
                        </button>
                    </span>
                );
            }
        }
    ];

    /* ─── Handlers (unchanged logic) ─── */
    const handleDeleteClick = (costId) => {
        const confirmDelete = window.confirm("Are you sure you want to delete this database config?");
        if (confirmDelete) {
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': { 'configId': costId },
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData = { 'token': EncryptData };
            deleteDbConigure(oData).then(function (res) {
                if ((typeof (res.data.errors) !== "undefined") && res.data.errors.errno > 0) {
                    setErrMsg(res.data.message);
                    setSuccess(false);
                } else {
                    setSuccess(res.data.message);
                    getDbConfigurationList(oData);
                }
            });
        } else {
            window.location.reload();
        }
    };

    const handleUpdatestatus = (costId, currentStatus) => {
        const newStatus = currentStatus === 1 ? 0 : 1;
        const statusText = newStatus === 1 ? 'activate' : 'deactivate';
        const confirmUpdate = window.confirm(`Are you sure you want to ${statusText} this database config?`);
        if (confirmUpdate) {
            let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
                'param_data': { 'configId': costId, status: newStatus },
                'authToken': sessionStorage.getItem('LoggedInToken'),
            }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
            let oData = { 'token': EncryptData };
            updateDbConigure(oData).then(function (res) {
                if ((typeof (res.data.errors) !== "undefined") && res.data.errors.errno > 0) {
                    setErrMsg(res.data.message);
                    setSuccess(false);
                } else {
                    setSuccess(res.data.message);
                    window.location.reload();
                }
            });
        }
    };

    /* ─── Data fetch (unchanged logic) ─── */
    useEffect(() => {
        let EncryptData = CryptoJS.AES.encrypt(JSON.stringify({
            'authToken': sessionStorage.getItem('LoggedInToken'),
        }), process.env.REACT_APP_ENCRYPT_SECRET_KEY).toString();
        let oData = { 'token': EncryptData };
        setLoading(true);
        getDbConfigurationList(oData)
            .then((res) => {
                if (res?.data?.data?.length) setItems(res.data.data);
                setSuccess(true);
            })
            .catch((error) => {
                setErrMsg(error.message);
                setSuccess(false);
            })
            .finally(() => setLoading(false));
    }, []);

    /* ════════════════════════════
       RENDER
       ════════════════════════════ */
    return (
        <div className="al-page" id="db-configure-list-page">

            {/* ══ PAGE HEADER ══ */}
            <div className="al-page-header" id="al-page-header">
                <div className="al-page-header-left">
                    <div className="al-page-header-icon">
                        <i className="bi bi-server" />
                    </div>
                    <div className="al-page-header-text">
                        <h5 className="al-page-title">DB Configuration List</h5>
                        <p className="al-page-subtitle">Manage database connections for all configured companies</p>
                    </div>
                </div>
                {!loading && (
                    <div className="al-record-badge" id="al-record-badge">
                        <i className="bi bi-layers-fill" />
                        <strong>{items.length.toLocaleString('en-IN')}</strong>&nbsp;Total Records
                    </div>
                )}
            </div>

            {/* ══ ALERTS ══ */}
            {errMsg && (
                <div className="alert alert-danger" role="alert">
                    <i className="bi bi-exclamation-triangle-fill" /> {errMsg}
                </div>
            )}

            {/* ══ DATA GRID CARD ══ */}
            <div className="al-grid-card" id="al-grid-card">
                <div className="al-grid-card-header">
                    <span className="al-grid-card-title">
                        <i className="bi bi-table" /> Configuration Records
                    </span>
                    {!loading && items.length > 0 && (
                        <span className="al-showing-badge">
                            Showing <strong>{items.length}</strong> record{items.length !== 1 ? 's' : ''}
                        </span>
                    )}
                </div>

                <Box>
                    {loading ? (
                        <div className="al-loader-wrap">
                            <div className="spinner-border text-primary" role="status">
                                <span className="visually-hidden">Loading…</span>
                            </div>
                            <p className="al-loader-text">Loading configurations…</p>
                        </div>
                    ) : (
                        <DataGrid
                            rows={items}
                            getRowId={(row) => row.company_id}
                            columns={columns}
                            pageSize={50}
                            rowsPerPageOptions={[50]}
                            autoHeight
                            className="al-data-grid"
                            sx={{
                                border: 'none',
                                fontFamily: "var(--font-body)",
                                '& .MuiDataGrid-columnHeaders': {
                                    color: '#fff', fontSize: '0.75rem', fontWeight: 700,
                                    textTransform: 'uppercase', letterSpacing: '0.5px', borderBottom: 'none',
                                },
                                '& .MuiDataGrid-columnHeaderTitle':    { color: '#000', fontSize: '0.88rem' },
                                '& .MuiDataGrid-sortIcon':             { color: 'rgb(46 45 45 / 85%)' },
                                '& .MuiDataGrid-menuIconButton':       { color: 'rgb(46 45 45 / 85%)' },
                                '& .MuiDataGrid-row':                  { fontSize: '0.8rem' },
                                '& .MuiDataGrid-row:hover':            { backgroundColor: '#eef7fd' },
                                '& .MuiDataGrid-row.Mui-selected':     { backgroundColor: '#d8f0fa' },
                                '& .MuiDataGrid-cell':                 { borderColor: '#f0f2f5' },
                                '& .MuiDataGrid-footerContainer':      { borderTop: '1px solid #e2e6ef', background: '#f8f9fc' },
                                '& .MuiDataGrid-virtualScroller':      { backgroundColor: '#fff' },
                            }}
                        />
                    )}
                </Box>
            </div>

        </div>
    );
}

export default DbConfigureList;